module.exports = __webpack_public_path__ + "media/images/resume-670085f02d92ed2acada52d538c6ef06.svg";